<template>
  <div class="content-center overflow-x-hidden bg-[#fafbfc] font-['Poppins']">
    <HeaderComponent />
    <slot></slot>
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from '../Components/HeaderComponent.vue';
import FooterComponent from '../Components/FooterComponent.vue';
import PageTransition from '../Components/PageTransition.vue';

export default {
  components: {
    HeaderComponent,
    FooterComponent,
    PageTransition
  }
};
</script>
